// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ozCejPnL4yzsJ4 {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.kos2yeJ8bcHAWx {
  align-items: flex-end;
}
.GggEZLbnXqNNe2 {
  align-items: flex-end;
  margin-top: -40px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"buttons": `ozCejPnL4yzsJ4`,
	"buttons--flipped": `kos2yeJ8bcHAWx`,
	"inboxCardButtons": `GggEZLbnXqNNe2`
};
export default ___CSS_LOADER_EXPORT___;
